import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { SquadCelebration } from '../SquadCelebration/index.tsx';
import { SquadInviteBlock } from '../SquadInviteBlock/index.tsx';
import { SquadPrivateChip } from '../SquadPrivateChip/index.tsx';
import type { SquadJoined_squad } from './__generated__/index.graphql.ts';

type Props = {
  squad: SquadJoined_squad;
};

export const SquadJoined = ({ squad }: Props) => {
  const {
    id,
    name,
    joinSecret,
    membersCount,
    maxMembersCount,
    private: isPrivate,
  } = squad;

  return (
    <SquadCelebration
      title={<FormattedMessage defaultMessage="Squad Joined" />}
      squadName={name}
      footer={
        <SquadInviteBlock
          squadId={id}
          joinSecret={joinSecret}
          membersCount={membersCount}
          maxMembersCount={maxMembersCount}
        />
      }
    >
      {!!isPrivate && <SquadPrivateChip />}
    </SquadCelebration>
  );
};

SquadJoined.fragments = {
  squad: gql`
    fragment SquadJoined_squad on Squad {
      id
      name
      joinSecret
      membersCount
      maxMembersCount
      private
    }
  ` as TypedDocumentNode<SquadJoined_squad>,
};
